import { useMutationCreateResourceV2 } from './useMutationCreateResourceV2.js';

const useMutationCreateSubFolder = () => {
  const createResource = useMutationCreateResourceV2();
  return {
    ...createResource,
    mutate: (variables, options) => {
      createResource.mutate({
        data: {
          createType: "folder",
          body: {
            name: variables.folderName ?? "New folder",
            parentId: variables.parent.id
          },
          optimisticData: {
            parent: variables.parent
          }
        },
        disableToast: variables.disableToast,
        action: variables.action
      }, options);
    },
    mutateAsync: async (variables) => {
      const res = await createResource.mutateAsync({
        data: {
          createType: "folder",
          body: {
            name: variables.folderName ?? "New folder",
            parentId: variables.parent.id
          },
          optimisticData: {
            parent: variables.parent
          }
        },
        disableToast: variables.disableToast,
        action: variables.action
      });
      return res;
    }
  };
};

export { useMutationCreateSubFolder };
//# sourceMappingURL=useMutationCreateSubFolder.js.map
